import React from 'react';
import classNames from 'classnames';
import './Toggle.css';

export function Toggle({ 
  checked,
  onChange,
  disabled = false,
  label,
  size = 'md',
  className = '',
  ...props
}) {
  const toggleClasses = classNames(
    'agrisense-toggle',
    className
  );

  const switchClasses = classNames(
    'agrisense-toggle__switch',
    `agrisense-toggle__switch--${size}`,
    {
      'agrisense-toggle__switch--checked': checked,
      'agrisense-toggle__switch--disabled': disabled,
    }
  );

  const thumbClasses = classNames(
    'agrisense-toggle__thumb',
    `agrisense-toggle__thumb--${size}`,
    {
      'agrisense-toggle__thumb--checked': checked,
    }
  );

  return (
    <label className={toggleClasses}>
      <div 
        className={switchClasses} 
        onClick={() => !disabled && onChange(!checked)}
        data-testid="toggle"
        role="switch"
        aria-checked={checked}
        {...props}
      >
        <div className={thumbClasses}></div>
      </div>
      {label && (
        <span className="agrisense-toggle__label">{label}</span>
      )}
    </label>
  );
}